import {
  ChangeDetectionStrategy,
  Component,
  input,
  model,
  output,
} from '@angular/core';
import { SidebarNavChild, SidebarNavItem } from './sidebar-nav.types';

export interface SidebarNavClickEvent {
  item: SidebarNavItem;
  child?: SidebarNavChild;
}

@Component({
  selector: 'lib-sidebar-nav',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './sidebar-nav.component.html',
  styleUrl: './sidebar-nav.component.css',
})
export class SidebarNavComponent {
  readonly items = input.required<SidebarNavItem[]>();
  readonly activeId = model<string | null>(null);
  readonly itemClick = output<SidebarNavClickEvent>();

  protected onItemClick(item: SidebarNavItem): void {
    if (item.selectable === false) return;
    this.activeId.set(item.id);
    this.itemClick.emit({ item });
  }

  protected onChildClick(item: SidebarNavItem, child: SidebarNavChild): void {
    this.activeId.set(child.id);
    this.itemClick.emit({ item, child });
  }
}
